import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./../../assets/style/captcha.module.scss";
import { TextField } from "@pga/textfield";
import { useEffect, useState } from "react";
import { MdRefresh } from "react-icons/md";
import { ReactComponent as Spinner } from "./../../assets/icons/spinner.svg";
import { Timer } from "./components/timer";
export const Captcha = ({ data }) => {
    var _a;
    const [errorImg, setErrorImg] = useState(false);
    const [refreshTime, setRefreshTime] = useState(true);
    const { value, setValue } = data;
    const onRefreshClick = (e) => {
        e.preventDefault();
        data.getCaptcha();
        // refresh time by destroy component and make it agian
        setRefreshTime(false);
    };
    useEffect(() => {
        setRefreshTime(false);
    }, [data.resData]);
    // refresh time by destroy component and make it agian
    useEffect(() => {
        if (!refreshTime)
            setRefreshTime(true);
    }, [refreshTime]);
    const onTimesUp = () => {
        data.getCaptcha();
    };
    const CaptchaBtn = () => {
        return (_jsx("button", Object.assign({ className: styles["_refresh-btn"], onClick: onRefreshClick, disabled: data.isLoading }, { children: _jsx(MdRefresh, { size: 20 }) })));
    };
    // get captcha
    useEffect(() => {
        data.getCaptcha();
    }, []);
    function onKeyDownInput(e) {
        if (data.callBackFn && e.key === "Enter")
            data.callBackFn();
    }
    return (_jsxs("div", { children: [_jsxs("div", Object.assign({ className: styles["_container"] }, { children: [_jsx(TextField, { onChange: (e) => setValue(e.target.value), value: value, onKeyDown: onKeyDownInput, name: "captchaValue", placeholder: "\u06A9\u062F \u0627\u0645\u0646\u06CC\u062A\u06CC", icon: _jsx(CaptchaBtn, {}), className: styles["_text-field"], type: "number" }), data.isLoading ? (_jsx(Spinner, {})) : !errorImg && data.resData ? (_jsx("div", { children: _jsx("div", Object.assign({ className: styles["_img-wrap"] }, { children: _jsx("img", { onError: (e) => {
                                    console.log(e);
                                    setErrorImg(true);
                                }, src: data.resData.picture, alt: "captcha" }) })) })) : (_jsx("span", Object.assign({ className: styles["_error-load-pic"] }, { children: "\u062E\u0637\u0627 \u062F\u0631 \u06A9\u067E\u0686\u0627" })))] })), _jsx("div", { children: ((_a = data.resData) === null || _a === void 0 ? void 0 : _a.duration) && refreshTime ? (_jsx(Timer, { timeLimit: data.resData.duration, onTimesUp: onTimesUp, isHide: true })) : ("") })] }));
};
